import React, { useId } from "react";
import style from "./productlist.module.scss";
import { useProductContext } from "./product-context";
import {
  AttributeOption,
  AttributeSelectionType,
  AttributeType,
  Product,
  ProductAttribute,
} from "./types";
import { AttributeButtons } from "./AttributeButtons";
import { AttributeSelectList } from "./AttributeSelectList";
import { FancySelector } from "../FancySelector/FancySelector";

export const AttributeOptionUI: React.FunctionComponent<{
  value: ProductAttribute;
  product?: Product;
  selectType?: AttributeSelectionType;
}> = (props) => {
  const context = useProductContext();
  const attribute = props.value;
  const [hasValue, setHasValue] = React.useState(false);
  const [selectedValue, setSelected] = React.useState<AttributeOption | null>(
    null
  );

  const attributeSelectType: AttributeSelectionType =
    props.selectType || "select";

  const handleOptionSelection = (option: AttributeOption | undefined) => {
    if (option) {
      setSelected(option);
      context.setAttribute(option);
      setHasValue(true);
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const option = attribute.Options[0];
    option.Name = value;

    setHasValue(value.length > 0);

    if (option) {
      context.setAttribute(option);
    }
  };

  let errorMessage = "",
    validState = "";

  if (attribute.IsRequired && !hasValue) {
    errorMessage = attribute.Name + " is required.";
    validState = "invalid";
  }

  const attributeCssClass =
    attribute.Type === AttributeType.Custom
      ? "attribute-container-custom"
      : "attribute-container-select attribute-container";

  return (
    <div className={`${style.attributeContainer} ${attributeCssClass}`}>
      {attribute.Type === AttributeType.Selection && (
        <div className={`${validState}`}>
          {attributeSelectType === "button" && (
            <AttributeButtons
              onSelected={handleOptionSelection}
              options={attribute.Options}
            />
          )}
          {attributeSelectType === "select" && (
            <AttributeSelectList
              options={attribute.Options}
              onChange={handleOptionSelection}
              selectedOptionId={selectedValue?.Id}
              cssClass={validState}
              attribute={attribute}
            ></AttributeSelectList>
          )}
          {errorMessage && context.isValidated && (
            <span className="validation-error">{errorMessage}</span>
          )}
          {attributeSelectType === "fancy" && (
            <FancySelector
              attribute={attribute}
              onSelected={handleOptionSelection}
              options={attribute.Options}
              DisplayZero={attribute.DisplayZero || ""}
            />
          )}
        </div>
      )}
      {attribute.Type === AttributeType.Custom && (
        <CustomAttributeUI
          attribute={attribute}
          onChangeHandler={onChangeHandler}
          validState={validState}
          errorMessage={errorMessage}
        ></CustomAttributeUI>
      )}
    </div>
  );
};

export const CustomAttributeUI: React.FC<{
  attribute: ProductAttribute;
  validState: string;
  errorMessage: string;
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ attribute, validState, errorMessage, onChangeHandler }) => {
  const customInputId = useId();

  return (
    <div>
      <label htmlFor={customInputId} className={style.attributeName}>
        {attribute.Name}
      </label>
      <input
        id={customInputId}
        onChange={onChangeHandler}
        className={`form-control ${validState}`}
      ></input>
      {errorMessage && <span className="validation-error">{errorMessage}</span>}
    </div>
  );
};
